import { render, staticRenderFns } from "./PostOutput.vue?vue&type=template&id=da36ced4&scoped=true"
import script from "./PostOutput.vue?vue&type=script&lang=js"
export * from "./PostOutput.vue?vue&type=script&lang=js"
import style0 from "./PostOutput.vue?vue&type=style&index=0&id=da36ced4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da36ced4",
  null
  
)

export default component.exports